import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=bcd3e124&scoped=true&lang=pug&"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBanner.vue?vue&type=style&index=0&id=bcd3e124&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3e124",
  null
  
)

export default component.exports